import React from 'react'

import classes from './Profile.module.scss';

function Profile() {
	return (
		<div className={classes.profile}>
			<h1>Dashboard</h1>
		</div>
	)
}

export default Profile
